import { ActionsUnion, createAction } from 'app/shared/utils/action-helpers';

// Models
import {
  SearchActionTypes,
  SearchRequest,
  EntitySearchResponse,
  TxnEventsSearchResponse,
  TeamsSearchResponse,
  EntitySearchRequest,
} from 'app/modules/search/models';

export const entitiesSearch = (payload: EntitySearchRequest) =>
  createAction(SearchActionTypes.ENTITIES_SEARCH, payload);

export const entitiesSearchSuccess = (response: EntitySearchResponse) =>
  createAction(SearchActionTypes.ENTITIES_SEARCH_SUCCESS, response);

export const teamsSearch = (payload: SearchRequest) =>
  createAction(SearchActionTypes.TEAMS_SEARCH, payload);

export const teamsSearchSuccess = (response: TeamsSearchResponse) =>
  createAction(SearchActionTypes.TEAMS_SEARCH_SUCCESS, response);

export const removeTeamFromSearch = (teamId: number) =>
  createAction(SearchActionTypes.REMOVE_TEAM_FROM_SEARCH, teamId);

export const txnEventsSearch = (payload: SearchRequest) =>
  createAction(SearchActionTypes.TXN_EVENTS_SEARCH, payload);

export const txnEventsSearchSuccess = (response: TxnEventsSearchResponse) =>
  createAction(SearchActionTypes.TXN_EVENTS_SEARCH_SUCCESS, response);

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const SearchReduxActions = {
  entitiesSearchSuccess,
  txnEventsSearchSuccess,
  teamsSearchSuccess,
  removeTeamFromSearch,
};

export type SearchActions = ActionsUnion<typeof SearchReduxActions>;
